import React, { FC } from 'react';
import { BubbleText, BubbleWrapper } from './styles';

type Props = {
  bubbleText?: string;
};

const TextBubble: FC<Props> = ({
  bubbleText = 'Simplesmente incrível!! Fizemos uma festa de final de ano em nossa construtora e os doces ficaram brilhantemente harmoniosos com o tema do nosso trabalho. Todo mundo adorou!',
}) => (
  <BubbleWrapper>
    <BubbleText>{bubbleText}</BubbleText>
  </BubbleWrapper>
);

export default TextBubble;
